/* istanbul ignore file */
import _ from 'underscore';
import { BackboneSchema as backboneSchema } from '@bingads-webui/backbone-schema';
import { getHotelCenterService } from '@bingads-webui-campaign/hotel-center-service';

export const getHotelGroupModel = ({
  i18n, hotelGroupSchema, state, jsdata, edm,
}) => {
  if (!i18n || !hotelGroupSchema || !state || !jsdata || !edm) {
    return {};
  }
  const { gridOptionUtils } = getHotelCenterService({ edm, state });
  // eslint-disable-next-line no-param-reassign
  hotelGroupSchema.properties.Name.required = true;
  const SchemaModel = backboneSchema(hotelGroupSchema, i18n, ['Name']);

  /**
   * HotelGroup backbone model based on hotelGroupSchema
   * @extends Backbone.Model
   */

  class HotelGroupModel extends SchemaModel {
    initialize(options = {}) {
      if (options.Id) {
        this.id = options.Id;
      }

      this.set('Name', options.Name);
      this.set('Id', options.Id);
      this.entitySet = options.entitySet || gridOptionUtils.getEntitySetByName('hotelGroup');
    }

    get idAttribute() {
      return 'Id';
    }

    toJSON() {
      const json = super.toJSON();

      this.attachNestedModels(json, ['BidSetting', 'Bid', 'BidMultipliers', 'Id']);

      return json;
    }

    sync(method, model, options) {
      const json = this.toJSON();

      switch (method) {
        case 'read':
          return jsdata.HotelGroup
            .find(this.get('Id'), {
              entitySet: this.entitySet,
            });
        case 'create':
          state.unset('subAccount_hotelGroupCount');
          return jsdata.HotelGroup.create(json, {
            cacheResponse: false,
            entitySet: this.entitySet,
          });
        case 'patch':
        case 'update':
          if (_.has(json, 'Bid') && json.Bid.Amount === null) {
            json.Bid = null; // if user didn't input Bid amout, pass null object to odata
          }
          return jsdata.HotelGroup.update(
            model.id,
            _.isEmpty(options.attrs) ? json : _.pick(json, options.attrs),
            {
              cacheResponse: false,
              entitySet: this.entitySet,
            }
          );
        case 'delete':
          state.unset('subAccount_hotelGroupCount');
          return jsdata.HotelGroup.destroy(model.id, {
            entitySet: this.entitySet,
          });
        default:
          throw new Error(`sync method ${method} is not supported`);
      }
    }

    attachNestedModels(json, fieldNames) {
      _.each(fieldNames, (field) => {
        if (this.has(field) || _.contains(this.changedAttributes(), 'BidSetting')) {
          json[field] = this.get(field); // eslint-disable-line
        }
      });
    }
  }

  return {
    HotelGroupModel,
  };
};
